import React, { Component } from 'react';
import { Grid, Row, Col, Icon } from 'rsuite';

class Keynote1 extends Component {

    componentDidMount = () => {
        // console.log(this.props)
    }


  render() {
    return (
      <div className="r_container">
        <div className="home">
            <div className="new_banner">
            <div className="banner_content">
              <h1>AIR-RES 2025</h1>
              <h6>The 2025 International Conference on the</h6>
              <h6>AI Revolution: Research, Ethics, and Society</h6>
              <h6>April 14-16, 2025, Las Vegas, USA</h6>
            </div>

            <div className="new_banner_overlay"></div>
          </div>
          

          <div className="page_content">
            <h4 className="par_header">Keynotes/Invited Lectures</h4>
            <br />
            <div style={{textAlign: "center"}}>
              <b>AI Utilization in Cybersecurity as a Double-Edged Sword</b> <br/>
              <br />Dr. Ali Al-Sinayyid, PhD <br/>
              Assistant Professor | Director, WVSU Cybersecurity Innovation Center<br />
              WVSU Cybersecurity Research Team Leader<br />
              Department of Math, Computer Science, and Engineering<br />
              College of Natural Sciences and Mathematics, West Virginia State University<br />
              West Virginia, USA<br />
            </div>
        
            <h6 className="par_header">Abstract:</h6>
            <div className="par">
              Artificial Intelligence (AI) is reshaping the cybersecurity landscape, acting as both a formidable defense mechanism and a powerful tool for adversaries. AI enhances threat detection, automates incident response, and strengthens predictive analytics. However, it also empowers attackers with sophisticated automated exploits, AI-driven phishing, and adaptive malware. This talk explores AI’s dual role in cybersecurity, illustrating how attackers and defenders leverage AI. We discuss challenges in AI-driven security, ethical concerns, and the looming impact of quantum computing on both offense and defense. The key takeaway: defenders must adopt AI-driven cybersecurity strategies or risk falling behind adversaries who are already weaponizing AI.
            </div>

            <h6 className="par_header">Speaker's Biography:</h6>
            <div className="par">
              Dr. Ali Al-Sinayyid is an esteemed cybersecurity expert, researcher, and educator with over 17 years of experience in academia and industry. He currently serves as the Director of the Cybersecurity Innovation Center at West Virginia State University (WVSU), where he leads initiatives in cybersecurity research, workforce development, and industry partnerships. Dr. Al-Sinayyid leads a research team in artificial intelligence applications in cybersecurity, critical infrastructure protection, and advanced threat detection. His work has earned significant recognition, securing over $4 million in grants from institutions such as Google, the Kanawha County Commission, and the U.S. Department of Education.
              He has also collaborated with industry leaders such as IBM, Amazon, and Cisco to bridge the gap between research and practical cybersecurity solutions.
              <br/> <br/>
              <div style={{textAlign: "center"}}>
                <img src="/static/al-sinayyid.jpg" height="300px" alt=""/>
              </div>
            </div>          
          </div>
          

        </div>
      </div>
    );
  }
}

export default Keynote1;